import { Link } from 'react-router-dom';

import { typographyVariants } from '@/components/ui/typography';
import { cn } from '@/lib/utils';
import { ROUTES } from '@/config/routes';
import { landingCopy as copy } from './copy';

/** The customer's "Tell us you're interested" link under each coming-soon tile (spec §4.5). A /home route, so it lives with the landing, not the shared tile. */
export const ComingSoonInterestLink = () => (
  <Link
    to={{ pathname: ROUTES.HELP_CONTACT, search: '?openSupport=true' }}
    className={cn(
      typographyVariants({ variant: 'body-sm-medium' }),
      'mt-auto text-primary underline-offset-4 hover:underline max-lg:flex max-lg:min-h-11 max-lg:items-center',
    )}
  >
    {copy.directory.interested}
  </Link>
);
